"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  rootLink: {
    display: 'flex',
    alignItems: 'center',
    color: _theme.default.palette.primary.light,
    fontSize: 'inherit',
    margin: '0 51px 8px 0',
    fontFamily: _theme.default.typography.proxima.regular,
    '& svg': {
      height: '21px',
      marginLeft: '4px'
    },
    '&:disabled': {
      color: _theme.default.palette.grayScale.disabled
    },
    [_theme.default.breakpoints.up('sm')]: {
      margin: '0 30px 8px 0'
    },
    '&.withoutRightMargin': {
      margin: '0 0 8px 0'
    }
  }
});
var _default = exports.default = useStyles;